module.exports = __webpack_public_path__ + "img/asian-thick-noodles-1.c4735011.jpg";